import { inject, injectable } from "inversify";
import { ICPLAddressesClient, UpdateAddressModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IAddressesService {
  updateAddress(model: UpdateAddressModel): Promise<void>;
}

@injectable()
export class AddressesService implements IAddressesService {
  @inject(SERVICE_TYPES.CPLAddressesClient) cplAddressesClient!: ICPLAddressesClient;

  async updateAddress(model: UpdateAddressModel): Promise<void> {
    return this.cplAddressesClient.updateAddress(model);
  }
}
